import { render } from "./TheNavigation.vue?vue&type=template&id=8084fe5e"
const script = {}

import "./TheNavigation.vue?vue&type=style&index=0&id=8084fe5e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__